import { thunk } from 'redux-thunk';
import logger from './logger';
import { applyMiddleware } from 'redux';

// apply all middleware here. thunk should always be first
export default applyMiddleware(thunk, logger);
